<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <feed-storages-form
      :id="id"
      :title="title"
      :item="item"></feed-storages-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
